import { render, staticRenderFns } from "./IncidentManagerElement.vue?vue&type=template&id=5468f306&scoped=true&"
import script from "./IncidentManagerElement.vue?vue&type=script&lang=js&"
export * from "./IncidentManagerElement.vue?vue&type=script&lang=js&"
import style0 from "./IncidentManagerElement.vue?vue&type=style&index=0&id=5468f306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5468f306",
  null
  
)

export default component.exports